/**
 * BE's `/prepare-upload` returns `filePath` as a signed URL fragment
 * (`<uuid>?Policy=…&Signature=…`). Resource write APIs (e.g. `/cm/create_resource`,
 * `/cm/update_resource`) expect the bare S3 key. Always pass `filePath` through
 * here before sending it server-side.
 */
export function toBareS3Key(signedFilePath: string): string {
  return signedFilePath.split('?')[0]
}
